import { VersionItem } from './types';

const hasIcon = (attribute: any) => {
  return !!attribute.images && !!attribute.images.icon && !!attribute.images.icon.png;
};

const toIconItem = (type: string, attribute: any): VersionItem => ({
  key: `icon-${type}`,
  kind: 'icon',
  value: attribute.images,
  alt: attribute.display_name,
});

const toTextItem = (type: string, attribute: any): VersionItem => ({
  key: `text-${type}`,
  kind: 'text',
  value: attribute.display_name,
});

const buildVersionItems = (version: any, attributes: any): VersionItem[] => {
  if (!version) {
    return [];
  }

  if (typeof version === 'string') {
    return [{ key: `text-${version}`, kind: 'text', value: version }];
  }

  const withAttributes = version.type.filter(type => type in attributes && !type.startsWith('lang_'));
  const withIcons = withAttributes.filter(type => hasIcon(attributes[type]));
  const withoutIcons = withAttributes.filter(type => !hasIcon(attributes[type]));

  const iconItems = withIcons.map(type => toIconItem(type, attributes[type]));
  const textItems = withoutIcons.map(type => toTextItem(type, attributes[type]));

  return iconItems.concat(textItems);
};

export default buildVersionItems;
